import type { ReactNode } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { type Permission, useAuth } from './AuthProvider';

/** Rutele private: fără sesiune → login, cu `from` pentru revenire. */
export function RequireAuth() {
  const { state } = useAuth();
  const location = useLocation();
  if (state.kind === 'unknown')
    return (
      <div className="muted" style={{ padding: 40 }}>
        Se încarcă sesiunea…
      </div>
    );
  if (state.kind === 'anonymous')
    return (
      <Navigate to="/autentificare" replace state={{ from: location.pathname + location.search }} />
    );
  return <Outlet />;
}

/** Ascunde ce nu e permis; serverul rămâne autoritatea. */
export function PermissionGate({
  permission,
  fallback = null,
  children,
}: {
  permission: Permission | Permission[];
  fallback?: ReactNode;
  children: ReactNode;
}) {
  const { has } = useAuth();
  const list = Array.isArray(permission) ? permission : [permission];
  return list.some(has) ? <>{children}</> : <>{fallback}</>;
}

export function Forbidden() {
  return (
    <div style={{ padding: 40 }}>
      <h1>Fără acces</h1>
      <p className="muted mt">Rolul tău nu include permisiunea pentru acest modul.</p>
    </div>
  );
}
